
















	import Vue from 'vue';
    import AnmeldungComp from "./AnmeldungComp.vue";
    import _termine from '../../services/endpoints/termine';
	import { MyActions } from '@/models/Store/State';

    export default Vue.extend({
        name: "ListAnmeldungEintragComp",
        components: {AnmeldungComp},
        props: ['anmeldung'],
        data: () => ({
            editOpen: false
        }),
        computed: {
            editAllowed: function(): boolean {
                return this.$vStore.getters.raidRole > 0;
            },
            termin: function(): any {
                return this.$vStore.getters.termin;
            }
        },
        methods: {
            anmeldungIcon: function(type: number): string {
                const icons = ['check_circle', 'check_circle_outline', 'cancel', 'help'];
                return icons[type];
            },
            anmeldungColor: function(type: number): string {
                const colors = ['green', 'yellow', 'red', 'grey'];
                return colors[type];
            },
            clickIcon: function(): void {
                this.editOpen = true;
            },
            anmelden: async function(type: any): Promise<void> {
                this.editOpen = false;
                await _termine.anmeldenLead(this.anmeldung.id, this.termin.id, type);
                await this.$vStore.dispatch(MyActions.Refresh);
                await this.$vStore.dispatch(MyActions.WsSendRefresh);
            }
        }
    })
